import props from './props'
import data from './data'
import components from './components'

export default {
  data,
  props,
  components
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/Items/resources/index.js